import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

/** Keeps a crash inside the migrated marketing tree from unmounting the whole dashboard. */
export default class MarketingErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[marketing] render failed', error, info.componentStack);
  }

  override render(): ReactNode {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div className="container py-4">
        <div className="alert alert-danger" role="alert">
          <h5 className="alert-heading">Influencer Marketing failed to render</h5>
          <p className="mb-2">{error.message}</p>
          <button className="btn btn-sm btn-outline-danger" onClick={() => this.setState({ error: null })}>
            Retry
          </button>
        </div>
      </div>
    );
  }
}
